// Contract addresses
export const HODL_JAR_FACTORY_ADDRESS = "0xfc54Ed05d0734e77546b593e52B0fEdb3D347367";
export const PAINTING_NFT_CONTRACT_ADDRESS = "0x834Cb4244C21b9465c62Aa92b21f53a233E69Ac4";